(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.tpfSyncBoxDiscount) return;
  const baseFetch = window.fetch.bind(window);
  const root = window.Shopify?.routes?.root || '/';
  const bundleId = 'ftqn5f6p';
  const isBoxCode = code => /^BUILD_A_BOX_DISCOUNT_.+_ftqn5f6p$/i.test(code || '');
  const isBoxSubscription = item => item.properties?.['_appstle-bb-id'] === bundleId && item.selling_plan_allocation;
  const hasBox = cart => cart.items?.some(isBoxSubscription);
  const hasBoxRows = () => [...document.querySelectorAll('[data-box-properties]')].some(row => {
    try { return Object.fromEntries(JSON.parse(row.dataset.boxProperties))['_appstle-bb-id'] === bundleId; } catch { return false; }
  });
  const errorCopy = () => {
    try { return JSON.parse(document.querySelector('[data-box-cart-copy]')?.textContent || '{}').discount_error; } catch { return ''; }
  };
  const showError = () => {
    const cart = document.querySelector('#main-cart');
    if (!cart || cart.querySelector('[data-box-discount-error]')) return;
    const notice = document.createElement('p');
    notice.dataset.boxDiscountError = '';
    notice.setAttribute('role', 'alert');
    notice.textContent = errorCopy();
    cart.querySelector('.title-wrapper-with-link')?.after(notice);
  };
  const request = async (url, options) => {
    const response = await baseFetch(url, options);
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || errorCopy());
    return result;
  };
  const post = data => ({method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(data)});
  const refreshSections = sections => {
    Object.values(sections || {}).forEach(html => {
      if (!html) return;
      const parsed = new window.DOMParser().parseFromString(html, 'text/html');
      ['#main-cart .js-cart-items', '#main-cart .js-subtotal', '#main-cart .js-free-shipping-bar',
        '#CartDrawer-CartItems', '#CartDrawer .cart-drawer__footer > .totals', '#CartDrawer .cart-drawer__footer > .pb-1',
        '#CartDrawer .js-free-shipping-bar', '#cart-icon-bubble'].forEach(selector => {
        const current = document.querySelector(selector);
        const next = parsed.querySelector(selector) || [...parsed.querySelectorAll('template')]
          .map(template => template.content.querySelector(selector)).find(Boolean);
        if (current && next) current.innerHTML = next.innerHTML;
      });
    });
    document.querySelector('[data-box-discount-error]')?.remove();
  };
  const applyCode = async (code, cart, render, sections = []) => {
    if (!code) throw new Error(errorCopy());
    const applications = [...(cart.cart_level_discount_applications || []),
      ...(cart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application))];
    const codes = new Set((cart.discount_codes || []).map(discount => discount.code));
    applications.filter(application => application?.type === 'discount_code').forEach(application => codes.add(application.title));
    [...codes].filter(isBoxCode).forEach(code => codes.delete(code));
    if (code !== 'appstle_no_discount') codes.add(code);
    const payload = {discount:[...codes].filter(Boolean).join(',')};
    if (render || sections.length) {
      const ids = [...sections, ...(render ? ['cart-drawer'] : [])];
      if (render) ['#main-cart', '#cart-icon-bubble'].forEach(selector => {
        const id = document.querySelector(selector)?.closest('.shopify-section')?.id.replace(/^shopify-section-/, '');
        if (id) ids.push(id);
      });
      payload.sections = [...new Set(ids)];
      payload.sections_url = window.location.pathname;
    }
    let discounted;
    for (let attempt = 0; attempt < 4; attempt++) {
      discounted = await request(root + 'cart/update.js', post(payload));
      const application = discounted.discount_codes?.find(discount => discount.code.toLowerCase() === code.toLowerCase());
      if (code === 'appstle_no_discount' || application?.applicable !== false) break;
      if (attempt === 3) throw new Error(errorCopy());
      // A newly generated code can reach Shopify before its discount is available.
      await new Promise(resolve => window.setTimeout(resolve, 500 * 2 ** attempt));
    }
    if (render) refreshSections(discounted.sections);
    return discounted;
  };
  const allocationSignature = allocations => (allocations || []).map(allocation => {
    const application = allocation.discount_application || allocation;
    return [allocation.amount, application.type, application.title, application.value, application.value_type];
  });
  const discountSignature = cart => JSON.stringify({
    items:(cart.items || []).filter(isBoxSubscription).map(item => [item.variant_id, item.quantity,
      item.original_price, item.original_line_price, item.final_line_price,
      item.selling_plan_allocation.selling_plan.id, item.properties['_tpf_box_key'],
      item.properties['__appstle-bb-variants'], allocationSignature(item.line_level_discount_allocations)]),
    codes:(cart.discount_codes || []).map(discount => [discount.code, discount.applicable]).sort(),
    applications:allocationSignature(cart.cart_level_discount_applications)
  });
  let synchronizedSignature;
  let pending = Promise.resolve();
  window.tpfSyncBoxDiscount = ({render = true, sections = [], refresh = false, readOnly = false} = {}) => {
    pending = pending.catch(() => {}).then(async () => {
      let cart = await request(root + 'cart.js', {cache:'no-store'});
      if (readOnly) return cart;
      const staleQuantity = item => isBoxSubscription(item) &&
        item.properties['__appstle-bb-variants'] !== item.variant_id + ':' + item.quantity;
      for (let remaining = cart.items.length; remaining > 0; remaining--) {
        const item = cart.items.find(staleQuantity);
        if (!item) break;
        cart = await request(root + 'cart/change.js?appstleUpdateAllLineItems=true', post({
          id:item.key, quantity:item.quantity,
          properties:{...item.properties, '__appstle-bb-variants':item.variant_id + ':' + item.quantity}
        }));
      }
      if (cart.items.some(staleQuantity)) throw new Error(errorCopy());
      // Delivery apps update line properties while a shopper chooses their slot.
      // Reapplying an unchanged discount would make those apps reset that choice.
      if (discountSignature(cart) === synchronizedSignature) {
        if (!refresh) return cart;
        const refreshed = await request(root + 'cart/update.js', post({
          sections:['cart-drawer'], sections_url:window.location.pathname
        }));
        refreshSections(refreshed.sections);
        return refreshed;
      }
      let code = 'appstle_no_discount';
      if (hasBox(cart)) {
        const items = cart.items.filter(isBoxSubscription).map(item => {
          const price = Number(item.original_price ?? item.price);
          const linePrice = Number(item.original_line_price ?? price * item.quantity);
          return {...item, price, original_price:price, discounted_price:price, final_price:price,
            line_price:linePrice, original_line_price:linePrice, final_line_price:linePrice,
            total_discount:0, discounts:[], line_level_discount_allocations:[]};
        });
        const subtotal = items.reduce((total, item) => total + item.original_line_price, 0);
        const eligibilityCart = {...cart, items, total_price:subtotal, original_total_price:subtotal,
          items_subtotal_price:subtotal, total_discount:0, item_count:items.reduce((total,item) => total + item.quantity,0),
          cart_level_discount_applications:[], discount_codes:[]};
        const prefix = String(window.appstle_app_proxy_path_prefix || 'apps/subscriptions').replace(/^\/+|\/+$/g, '');
        const response = await request('/' + prefix + '/bb/api/subscription-bundlings/discount/' + bundleId,
          {...post({cart:eligibilityCart}), method:'PUT'});
        code = response.discountCode || 'appstle_no_discount';
      }
      const discounted = await applyCode(code, cart, render, sections);
      synchronizedSignature = discountSignature(discounted);
      return discounted;
    });
    return pending;
  };
  window.fetch = async function(input, options) {
    const url = new URL(String(input?.url || input), window.location.href);
    if (url.origin === window.location.origin && /\/discount\/BUILD_A_BOX_DISCOUNT_.+_ftqn5f6p$/i.test(url.pathname)) return new Response(null, {status:204});
    if (url.origin === window.location.origin && url.pathname.endsWith('/bb/api/subscription-bundlings/discount/' + bundleId)) {
      if (!window.tpfBoxFinishing) await window.tpfSyncBoxDiscount();
      // Use one current basket for eligibility; an older Appstle snapshot could
      // create a competing code based on already-discounted prices.
      return new Response(JSON.stringify({discountCode:null}), {headers:{'Content-Type':'application/json'}});
    }
    const hadBox = hasBoxRows();
    const response = await baseFetch(input, options);
    if (url.origin !== window.location.origin || !response.ok) return response;
    if (hadBox && !document.querySelector('[data-tpf-build-box]') && /\/cart\/change(?:\.js)?$/.test(url.pathname)) {
      const cart = await response.clone().json();
      const discounted = await window.tpfSyncBoxDiscount({render:false, sections:Object.keys(cart.sections || {})});
      // The theme renders this response after the quantity change. Return the
      // confirmed prices and its requested sections so it cannot restore old totals.
      return new Response(JSON.stringify({...cart, ...discounted, sections:discounted.sections || cart.sections}),
        {status:response.status, headers:{'Content-Type':'application/json'}});
    }
    return response;
  };
  window.tpfBoxDiscountError = showError;
})();

(() => {
  if (window.tpfBoxCartReady) return;
  window.tpfBoxCartReady = true;
  const expanded = new Map();
  const money = n => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:'USD'}).format(n / 100);
  const text = (node,value) => { if (node.textContent !== value) node.textContent = value; };
  let scheduled = false;
  let drawerWasOpen = false;
  const run = () => {
    scheduled = false;
    const copyNode = document.querySelector('[data-box-cart-copy]');
    if (!copyNode) { document.querySelector('[data-box-confirmation]')?.remove(); return; }
    const copy = JSON.parse(copyNode.textContent);
    const groups = new Map();
    document.querySelectorAll('[data-box-properties]').forEach(row => {
      let properties;
      try { properties = Object.fromEntries(JSON.parse(row.dataset.boxProperties)); } catch { return; }
      if (properties['_appstle-bb-id'] !== 'ftqn5f6p') return;
      const key = properties['_appstle-bb-id'] + ':' + (properties['_tpf_box_key'] || '') + ':' + row.dataset.boxPlan;
      const parent = row.parentElement;
      if (!groups.has(parent)) groups.set(parent, new Map());
      const table = groups.get(parent);
      if (!table.has(key)) table.set(key, []);
      table.get(key).push(row);
    });
    groups.forEach((table, parent) => table.forEach((rows, key) => {
      let group = [...parent.querySelectorAll('.tpf-box-group')].find(e => e.dataset.boxKey === key);
      if (!group) {
        group = document.createElement('tr');
        group.className = 'tpf-box-group';
        group.dataset.boxKey = key;
        const cell = document.createElement('td');
        cell.colSpan = 4;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'tpf-box-group__toggle';
        button.addEventListener('click', () => { expanded.set(key, !expanded.get(key)); run(); });
        cell.append(button);
        group.append(cell);
        rows[0].before(group);
      }
      const open = expanded.get(key) || false;
      const count = rows.reduce((n, row) => n + Number(row.querySelector('input[name="updates[]"]')?.value || 0), 0);
      const total = rows.reduce((n, row) => n + Number(row.dataset.boxLineTotal || 0), 0);
      const original = rows.reduce((n, row) => n + Number(row.dataset.boxLineOriginal ?? row.dataset.boxLineTotal ?? 0), 0);
      const button = group.querySelector('button');
      if (!button.querySelector('[data-box-group-total]')) button.innerHTML = '<span class="tpf-box-group__title"><span data-box-group-title></span><span class="tpf-box-group__prices"><s data-box-group-original hidden></s><span data-box-group-total></span></span></span><span data-box-group-details></span><span data-box-group-action></span>';
      text(button.querySelector('[data-box-group-title]'),copy.custom_box + ' ·');
      const originalPrice = button.querySelector('[data-box-group-original]');
      text(originalPrice,money(original));
      originalPrice.hidden = original <= total;
      originalPrice.setAttribute('aria-label',(copy.original_total || '') + ' ' + money(original));
      text(button.querySelector('[data-box-group-total]'),money(total));
      text(button.querySelector('[data-box-group-details]'),copy.items.replace('__COUNT__', String(count)) + ' · ' + (rows[0].dataset.boxPlan || ''));
      text(button.querySelector('[data-box-group-action]'),copy.view_items + ' ' + (open ? '⌃' : '⌄'));
      button.setAttribute('aria-expanded', String(open));
      button.setAttribute('aria-controls', rows.map(row => row.id).join(' '));
      rows.forEach(row => { if (row.classList.contains('tpf-box-line-hidden') === open) row.classList.toggle('tpf-box-line-hidden', !open); });
    }));
    document.querySelectorAll('.tpf-box-group').forEach(group => {
      const table = groups.get(group.parentElement);
      if (!table?.has(group.dataset.boxKey)) group.remove();
    });
    if (!groups.size) document.querySelector('[data-box-confirmation]')?.remove();
    if (new URLSearchParams(location.search).has('box_added') && groups.size && document.querySelector('#main-cart')) {
      if (!document.querySelector('[data-box-confirmation]')) {
        const notice = document.createElement('p');
        notice.className = 'tpf-box-confirmation';
        notice.dataset.boxConfirmation = '';
        notice.setAttribute('role','status');
        notice.textContent = copy.added;
        document.querySelector('#main-cart .title-wrapper-with-link')?.after(notice);
        try { sessionStorage.removeItem('tpf-box-draft-ftqn5f6p'); } catch {}
      }
    }
    const drawerIsOpen = Boolean(document.querySelector('cart-drawer.active #CartDrawer .tpf-box-group'));
    const openingDrawer = drawerIsOpen && !drawerWasOpen;
    drawerWasOpen = drawerIsOpen;
    if (openingDrawer) window.tpfSyncBoxDiscount?.({refresh:true}).catch(() => window.tpfBoxDiscountError?.());
  };
  const observer = new MutationObserver(records => {
    if (!records.some(record => record.type === 'childList' || record.target.matches('cart-drawer'))) return;
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(run);
  });
  observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
  document.addEventListener('change', run);
  run();
  if (document.querySelector('#main-cart') && document.querySelector('.tpf-box-group')) {
    window.tpfSyncBoxDiscount?.().catch(() => window.tpfBoxDiscountError?.());
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tpf-build-box-zip-gate"] && !Shopify.designMode) return;
  try {
    (() => {
    const rootSelector = "[data-tpf-build-box]";
    const stateKey = "tpf_delivery_zip";
    const template = document.getElementById("TpfBuildBoxZipGateTemplate");

    if (!template) return;

    const readStoredState = () => {
      try {
        const state = JSON.parse(localStorage.getItem(stateKey) || "null");
        return state && state.version === 1 ? state : null;
      } catch {
        return null;
      }
    };

    const getState = () => {
      return window.TPFCatalogEligibility?.getState?.() || readStoredState();
    };

    const getStatus = (state) => {
      if (state?.eligibility === "local") return "local";
      if (state?.eligibility === "out_of_area") return "unavailable";
      return "unknown";
    };

    const openZipChecker = () => {
      if (window.TPFCatalogEligibility?.openGate) {
        window.TPFCatalogEligibility.openGate();
        return;
      }

      if (window.ZipDelivery?.openChecker) {
        window.ZipDelivery.openChecker("zip-check");
        return;
      }

      document.querySelector("a[href=\"#zip-check\"]")?.click();
    };

    const renderRoot = (root, state) => {
      const shell = root.querySelector("[data-tpf-bab-shell]");
      const gate = root.querySelector("[data-tpf-bab-zip-gate]");
      const unknown = gate?.querySelector("[data-tpf-bab-zip-unknown]");
      const unavailable = gate?.querySelector("[data-tpf-bab-zip-unavailable]");
      const status = getStatus(state);

      if (!shell || !gate || !unknown || !unavailable) return;

      root.dataset.tpfBabZipStatus = status;
      shell.hidden = status !== "local";
      shell.inert = status !== "local";
      gate.hidden = status === "local";
      unknown.hidden = status !== "unknown";
      unavailable.hidden = status !== "unavailable";

      gate.querySelectorAll("[data-tpf-bab-current-zip]").forEach((element) => {
        element.textContent = state?.zip || "";
      });
    };

    const initializeRoot = (root) => {
      if (root.dataset.tpfBabZipGateReady === "true") return;

      const shell = root.querySelector("[data-tpf-bab-shell]");
      if (!shell) return;

      const gate = template.content.firstElementChild.cloneNode(true);
      shell.before(gate);
      root.dataset.tpfBabZipGateReady = "true";

      gate.querySelectorAll("[data-tpf-bab-open-zip]").forEach((button) => {
        button.addEventListener("click", openZipChecker);
      });

      renderRoot(root, getState());
    };

    const initialize = (scope = document) => {
      if (scope.matches?.(rootSelector)) initializeRoot(scope);
      scope.querySelectorAll?.(rootSelector).forEach(initializeRoot);
    };

    const renderAll = (state = getState()) => {
      document.querySelectorAll(rootSelector).forEach((root) => renderRoot(root, state));
    };

    const boot = () => {
      initialize();
      renderAll();

      const designMode = document.documentElement.classList.contains("shopify-design-mode");
      if (!designMode && getStatus(getState()) === "unknown") {
        window.setTimeout(openZipChecker, 350);
      }
    };

    window.addEventListener("tpf:zip-changed", (event) => {
      renderAll(event.detail);
    });

    window.addEventListener("zipdelivery:updated", () => {
      window.requestAnimationFrame(() => renderAll());
    });

    window.addEventListener("storage", (event) => {
      if (event.key === stateKey) renderAll();
    });

    document.addEventListener("shopify:section:load", (event) => {
      initialize(event.target);
      renderAll();
    });

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", boot, { once: true });
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
